$(function () {

    function resizeFunction() {
        $(".ar-page-header,.ar-compact-header-block-container,.ar-page-footer").each(function (index, element) {
            var imageElement = $(".ar-page-header__image,.ar-compact-header-block__image,.ar-page-footer__image", element);
            if (!imageElement.length) {
                return;
            }

            if (window.innerWidth <= 767 || 
                (window.innerWidth <= 1024 && element.classList.contains("ar-compact-header-block-container"))) {
                imageElement.removeAttr("style");
                return;
            }

            var imageElementSize = element.getBoundingClientRect();

            var imageWidth = imageElement[0].naturalWidth;
            var imageHeight = imageElement[0].naturalHeight;

            var viewportWidth = window.screen.width;
            if (window.innerWidth > viewportWidth) {
                viewportWidth = window.innerWidth;
            }

            var viewportHeight = window.screen.height;
            if (window.innerHeight > viewportHeight) {
                viewportHeight = window.innerHeight;
            }

            if (imageElementSize.height > viewportHeight) {
                viewportHeight = imageElementSize.height;
            }

            var ratio = viewportWidth / imageWidth;
            var ratio2 = viewportHeight / imageHeight;

            if (ratio2 > ratio) {
                ratio = ratio2
            }

            imageElement.width(imageWidth * ratio);
            imageElement.height(imageHeight * ratio);

            imageElement.css("left", (imageElement.width() - viewportWidth) / -2);
        });
    }

    function scrollFunction() {
        if (window.innerWidth <= 767) {
            return;
        }

        $(".ar-page-header,.ar-compact-header-block-container,.ar-page-footer").each(function (index, element) {
            var imageElement = $(".ar-page-header__image,.ar-compact-header-block__image,.ar-page-footer__image", element);
            if (!imageElement.length) {
                return;
            }

            if (window.innerWidth <= 1024 && element.classList.contains("ar-compact-header-block-container")) {
                return;
            }            

            imageElement.css("top", element.getBoundingClientRect().top * -0.5);
        });
    }

    var updating = false;
    $(window).on("scroll", function (e) {
        if (!updating) {
            window.requestAnimationFrame(function () {
                scrollFunction();

                updating = false;
            });
            updating = true;
        }
    });

    $(window).on("resize", function (e) {
        if (!updating) {
            window.requestAnimationFrame(function () {
                resizeFunction();

                updating = false;
            });
            updating = true;
        }
    });

    $(".ar-page-header__image,.ar-compact-header-block__image,.ar-page-footer__image").on("load", function () {
        resizeFunction();
    });

    resizeFunction();
    scrollFunction();
});

